module.exports = __webpack_public_path__ + "static/media/03_controller_port.c43f797e.jpg";